import $http from "../../../axios-instance";
import Swal from "sweetalert2";

/**
 * Actualiza los estados para bloquearo desbloquear una empresa dependiendo si tiene un bloqueo activo.
 *
 * @author Libardo Bolaño
 * @param {commit,state,dispatch} param0
 * @param {object} company
 */
export function blockCompany({commit,state,dispatch}, company) {
    commit('setCompany',company);
    const companyId =  company.id;
    commit('setModal',true);
    commit('setAction','BLOCK_COMPANY');
    const type = (company.insured_status === 'BLOCKED') ? 'UNBLOCKED' : 'BLOCKED';
    commit('addTypeCompanyBlockade',type);

    commit('setCompanyId',companyId);
}

/**
 * Actualiza los estados para mostrar el historias de bloqueos de una empresa.
 *
 * @author Libardo Bolaño
 * @param {commit,dispatch} param0
 * @param {object} company
 */
export async function historyBlocks({commit,dispatch}, company) {
    commit('setCompany',company);
    const companyId =  company.id;
    commit('setModal',true);
    commit('setAction','HISTORY_BLOCK');

    commit('setCompanyId',companyId);
    await dispatch('getHistoryBlocks');
}

/**
 * Reinicia los estados afetados cuando se despliega una acción d bloque de empresas.
 *
 * @author Libardo Bolaño
 * @param {commit,} param0
 */
export function resetBlockCompany({commit}) {
    commit('resetModal');
    commit('resetAction');

    commit('resetCompanyBlockade');
    commit('resetCompany');
}

/**
 * Ejecuta una acción de confirmación y una petición al servidor para desbloquear una empresa.
 *
 * @author Libardo Bolaño
 * @param {commit, state, dispatch} param0
 */
export async function unblockCompany({commit, state, dispatch}) {
    await Swal.fire({
        title: "Desbloquear empresa",
        text: `¿Está seguro que desea desquoquear la empresa ${state.company.nombre}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Desbloquear",
    }).then(async (result) => {
        if (result.isConfirmed) {
            await $http.post(`company-blockades/available/${state.company['id']}`,{})
            .then(async response => {
                this.$vue.$alertSuccess(response.data.message,3000);
                dispatch('resetBlockCompany');
                commit('setAction','UNBLOCK');
            })
            .catch(error => {
                this.$vue.$alertError(error.message);
            })
            .finally(() => commit('dashboard/load', false, { root: true }));
        }else commit('setAction','CANCEL-UNBLOCK');
    });
}

/**
 * Ejecuta una  petición al servidor para bloquear una empresa.
 *
 * @author Libardo Bolaño
 * @param {commit, state, dispatch} param0
 */
export async function createCompanyBlock({commit, state, dispatch}) {
    commit("dashboard/load", true, { root: true });
    await $http.post(`company-blockades`, state.companyBlockade)
    .then(async response => {
        this.$vue.$alertSuccess(response.data.message,3000);
    })
    .catch(error => {
        this.$vue.$alertError(error.message);
    })
    .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Lista todos los bloqueos de una empresa.
 *
 * @author Libardo Bolaño
 * @param {commit, state, dispatch} param0
 */
export async function getHistoryBlocks({commit, state, dispatch}) {
    commit("dashboard/load", true, { root: true });
    const companyId = state.company.id;
    const params = state.filter;
    await $http.get(`company-blockades/${companyId}`,{params})
    .then(async response => {
        commit('setCompanyBlockades',response.data.data);
    })
    .catch(error => {
        this.$vue.$alertError(error.message);
    })
    .finally(() => commit('dashboard/load', false, { root: true }));
}
